import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=22bc2d0b&"
import script from "./ClientsView.vue?vue&type=script&lang=js&"
export * from "./ClientsView.vue?vue&type=script&lang=js&"
import style0 from "./ClientsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports